import React from 'react';
import {createRoot} from 'react-dom/client';

import '../patterns/components/icon/icon/icons';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
import {App} from './App';

if (window.location.hostname === 'app.moticheck.com' || window.location.hostname === 'moticheck.energia.ee') {
    Sentry.init({
        dsn: 'https://e4a0ac0b5a3245e2add367db4863da28@o578723.ingest.sentry.io/5735109',
        integrations: [new Integrations.BrowserTracing()],
        environment: 'production',
        tracesSampleRate: 0.1,
    });
}

if (window.location.hostname === 'test.moticheck.com' || window.location.hostname === 'moticheck-test.energia.ee') {
    Sentry.init({
        dsn: 'https://e4a0ac0b5a3245e2add367db4863da28@o578723.ingest.sentry.io/5735109',
        integrations: [new Integrations.BrowserTracing()],
        environment: 'test',
        tracesSampleRate: 0.1,
    });
}

const container: HTMLElement | null = document.getElementById('page');

if (!container) {
    throw Error('Main render container not found');
}

const root = createRoot(container);

root.render(<App />);
